import { notification } from 'antd'
import axios, { AxiosError, AxiosInstance } from 'axios'
import { BASE_URL } from 'constants/index'
import { getToken } from './get-token.util'

class API {
  static instance: AxiosInstance

  constructor() {
    API.instance = axios.create({
      baseURL: BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    API.instance.interceptors.request.use(
      (config) => {
        const token = getToken()
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          }
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      },
    )

    API.instance?.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (error.response && error.response.status === 401 && error.response.config.url !== '/auth/login') {
          localStorage.removeItem('token')
          notification.error({ message: 'Session expired', description: 'You will be redirected to the Login page' })
          setTimeout(() => {
            window.location.href = '/login'
          }, 2000)
        }
        return Promise.reject(error)
      },
    )
  }

  async get(path: string, params?: Record<string, unknown>) {
    return API.instance.get(path, { params })
  }

  async post<T>(path: string, data?: T, config?: Record<string, unknown>) {
    return API.instance.post(path, data, config)
  }

  async put<T>(path: string, data?: T, config?: Record<string, unknown>) {
    return API.instance.put(path, data, config)
  }

  async delete(path: string, config?: Record<string, unknown>) {
    return API.instance.delete(path, config)
  }
}

export default new API()
